/**
 * Report-Definition für die Anforderungs-Liste (User Stories).
 *
 * Übersetzt die geladene Anforderungs-Liste in ein {@link ReportDocument}. Spalten
 * spiegeln die Kern-Spalten der UI-Tabelle: Nr, Rolle, Ziel/Story, Kategorie,
 * Story Points, Status. Leere Zellen werden als '—' dargestellt.
 */
import {
  buildDocument,
  tableBlock,
  type ReportBlock,
  type ReportDocument,
} from '../../../lib/pdf/reportModel';

export interface AnforderungReportItem {
  nr: string | null;
  role: string | null;
  ziel: string;
  kategorie: string | null;
  story_points: number | null;
  status: 'Neu' | 'In Planung' | 'Umgesetzt' | 'Abgenommen';
}

export interface AnforderungenReportInput {
  items: AnforderungReportItem[];
}

export function buildAnforderungenReport(input: AnforderungenReportInput): ReportDocument {
  const block: ReportBlock =
    input.items.length > 0
      ? tableBlock(
          [
            { header: 'Nr', weight: 0.9 },
            { header: 'Rolle', weight: 1.6 },
            { header: 'Ziel/Story', weight: 3 },
            { header: 'Kategorie', weight: 1.6 },
            { header: 'SP', weight: 0.7 },
            { header: 'Status', weight: 1.4 },
          ],
          input.items.map((a) => [
            a.nr || '—',
            a.role || '—',
            a.ziel || '—',
            a.kategorie || '—',
            a.story_points == null ? '—' : String(a.story_points),
            a.status || '—',
          ]),
        )!
      : { kind: 'note', value: 'Noch keine Anforderungen erfasst.' };

  return buildDocument([{ title: 'Anforderungen', blocks: [block] }]);
}
